var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14 0 0 3.14 0 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7Zm0 12.6A5.607 5.607 0 0 1 1.4 7c0-3.088 2.512-5.6 5.6-5.6 3.088 0 5.6 2.512 5.6 5.6 0 3.088-2.512 5.6-5.6 5.6Z",
    fill: "#8B8B95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.689 6.798a.697.697 0 0 0 .01-.11v-3.05a.7.7 0 0 0-1.399 0v3.05c0 .06-.007.738.213.935l2.165 1.94a.696.696 0 0 0 .988-.053.7.7 0 0 0-.054-.988L7.689 6.798Z",
    fill: "#8B8B95"
  })));
};

export default SvgClock;